import React from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import Layout from "@sellernote/shipda-kr/src/containers/Layout";
import Icon from "@sellernote/ui/src/sds-v1/components/Icon";
import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";

import SupportSearch from "./SupportSearch";
import Styled from "./index.styles";

export default function SupportLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation(["support-new"]);

  const router = useRouter();

  const {
    query: { searchTerm },
  } = router;

  return (
    <Layout size="full">
      <Styled.container>
        <Styled.titleHeader>
          <h2>
            {t("support-new:공통_제목")}
            {searchTerm && (
              <Icon
                type="arrowLeft"
                size={2}
                color={COLOR.grayScale_700}
                onClick={() => router.back()}
              />
            )}
          </h2>

          <p className="desc">{t("support-new:공통_안내")}</p>
        </Styled.titleHeader>

        <SupportSearch />

        <Styled.mainWrapper>
          <Styled.mainContainer>{children}</Styled.mainContainer>
        </Styled.mainWrapper>
      </Styled.container>
    </Layout>
  );
}
